import { render, staticRenderFns } from "./SegmentAddDialog.vue?vue&type=template&id=8040d312"
import script from "./SegmentAddDialog.vue?vue&type=script&lang=js"
export * from "./SegmentAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports